import React, { useEffect } from 'react';
import styled from 'styled-components';

const CustomizedSuccessCard = ({ message, onClose, autoCloseDuration = 3000 }) => {
  useEffect(() => {
    if (autoCloseDuration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDuration);
      return () => clearTimeout(timer);
    }
  }, [autoCloseDuration, onClose]);

  return (
    <NotificationWrapper>
      <NotificationContent>
        <IconWrapper>
          <svg fill="green" height={24} viewBox="0 0 24 24" width={24}>
            <circle cx="12" cy="12" r="10" stroke="green" strokeWidth="2" fill="none" />
            <path d="M8 12l2 2 4-4" stroke="green" strokeWidth="2" fill="none" />
          </svg>
        </IconWrapper>
        <MessageText>{message}</MessageText>
        <CloseButton onClick={onClose}>×</CloseButton>
      </NotificationContent>
    </NotificationWrapper>
  );
};

const NotificationWrapper = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  animation: slideIn 0.3s ease-in-out;

  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
`;

const NotificationContent = styled.div`
  background: linear-gradient(135deg, #edfbd8 0%, #d4f4dd 100%);
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(34, 100, 19, 0.2);
  min-width: 280px;
  max-width: 450px;
  border-left: 4px solid #4caf50;
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: green;
  }
`;

const MessageText = styled.div`
  flex: 1;
  color: #1b5e20;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.4;
  word-break: break-word;
`;

const CloseButton = styled.button`
  flex-shrink: 0;
  background: none;
  border: none;
  color: #2e7d32;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    color: #d32f2f;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export default CustomizedSuccessCard;
